import { render } from "./Shortfall.vue?vue&type=template&id=96f06758"
import script from "./Shortfall.vue?vue&type=script&lang=js"
export * from "./Shortfall.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__